import "/__w/1/s/BotFramework-WebChat/packages/component/src/ActivityFeedback/private/ThumbButton.module_built.css";
const classes = {"thumb-button__image":"wwPVtVa_thumb-button__image","thumb-button":"wwPVtVa_thumb-button","thumb-button__tooltip":"wwPVtVa_thumb-button__tooltip","thumb-button--large":"wwPVtVa_thumb-button--large","thumb-button__image--is-stroked":"wwPVtVa_thumb-button__image--is-stroked","thumb-button--has-submitted":"wwPVtVa_thumb-button--has-submitted","thumb-button__image--is-filled":"wwPVtVa_thumb-button__image--is-filled","thumb-button__input":"wwPVtVa_thumb-button__input"}
export default classes

const _thumb_button__image0 = classes["thumb-button__image"]
export { _thumb_button__image0 as "thumb-button__image" }

const _thumb_button0 = classes["thumb-button"]
export { _thumb_button0 as "thumb-button" }

const _thumb_button__tooltip0 = classes["thumb-button__tooltip"]
export { _thumb_button__tooltip0 as "thumb-button__tooltip" }

const _thumb_button__large0 = classes["thumb-button--large"]
export { _thumb_button__large0 as "thumb-button--large" }

const _thumb_button__image__is_stroked0 = classes["thumb-button__image--is-stroked"]
export { _thumb_button__image__is_stroked0 as "thumb-button__image--is-stroked" }

const _thumb_button__has_submitted0 = classes["thumb-button--has-submitted"]
export { _thumb_button__has_submitted0 as "thumb-button--has-submitted" }

const _thumb_button__image__is_filled0 = classes["thumb-button__image--is-filled"]
export { _thumb_button__image__is_filled0 as "thumb-button__image--is-filled" }

const _thumb_button__input0 = classes["thumb-button__input"]
export { _thumb_button__input0 as "thumb-button__input" }
